import { IMID } from '@entities/mid';

export const getMIDName = (mid: IMID) => {
  return `${mid.merchant.short_name}*${mid.currency_method.method.name}*${mid.currency_method.currency.code}*${mid.traffic}`;
};
